import { Form } from 'semantic-ui-react';
import classnames from 'classnames';
import './form-field.scss';

export default function FieldWrapper({ children, label, props, meta }) {
  return (
    <Form.Field
      className={classnames('form-field', {
        'form-field--has-error': meta?.touched && meta?.error,
      })}
    >
      <label className="form-field__label" htmlFor={props.id || props.name}>
        {label}
      </label>
      {children}
      {meta.touched && meta.error && (
        <div className="form-field__error-message">{meta.error}</div>
      )}
    </Form.Field>
  );
}
